var _path, _path2, _rect;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCenterAlignment(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.0306 3.90544H28.0306C28.3842 3.90544 28.7234 3.76496 28.9734 3.51491C29.2235 3.26486 29.3639 2.92572 29.3639 2.5721C29.3639 2.21848 29.2235 1.87934 28.9734 1.62929C28.7234 1.37925 28.3842 1.23877 28.0306 1.23877H4.0306C3.67698 1.23877 3.33784 1.37925 3.08779 1.62929C2.83774 1.87934 2.69727 2.21848 2.69727 2.5721C2.69727 2.92572 2.83774 3.26486 3.08779 3.51491C3.33784 3.76496 3.67698 3.90544 4.0306 3.90544Z",
    fill: "#CCA3CF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.60205 30.7609H27.4595C27.9647 30.7609 28.4491 30.6204 28.8064 30.3704C29.1636 30.1203 29.3643 29.7812 29.3643 29.4276C29.3643 29.0739 29.1636 28.7348 28.8064 28.4848C28.4491 28.2347 27.9647 28.0942 27.4595 28.0942H4.60205C4.09687 28.0942 3.61238 28.2347 3.25516 28.4848C2.89795 28.7348 2.69727 29.0739 2.69727 29.4276C2.69727 29.7812 2.89795 30.1203 3.25516 30.3704C3.61238 30.6204 4.09687 30.7609 4.60205 30.7609Z",
    fill: "#CCA3CF"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7.93555,
    y: 7.90625,
    width: 16.1885,
    height: 16.1885,
    rx: 2,
    fill: "#CCA3CF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCenterAlignment);
export default __webpack_public_path__ + "static/media/centerAlignment.45a5fcf0bdd24b6ac44457e352f23732.svg";
export { ForwardRef as ReactComponent };